import { useState, useEffect, useRef } from 'react';
import api from '../services/api';
import { useAuthStore } from '../store';
import toast from 'react-hot-toast';

const C = {
  bg:'#0A0E1A', surface:'#111827', card:'#0D1526',
  accent:'#00D4AA', gold:'#F59E0B', border:'#1e2d45',
  text:'#E8EDF5', muted:'#6b7fa3', red:'#FF4F6A',
};
const fmt = (n) => parseFloat(n||0).toLocaleString('fr-FR');
const CATEGORIES = ['Alimentation','Vetements','Electronique','Beaute','Maison','Services','Agriculture','Autre'];

export default function MarketplacePage({ onClose }) {
  const { user } = useAuthStore();
  const [tab, setTab] = useState('explore');
  const [shops, setShops] = useState([]);
  const [search, setSearch] = useState('');
  const [selectedShop, setSelectedShop] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  useEffect(() => { fetchShops(); }, []);

  const fetchShops = async (q='') => {
    try {
      const res = await api.get('/marketplace/search' + (q ? '?q='+q : ''));
      setShops(res.data?.shops || res.shops || []);
    } catch {}
  };

  if (selectedProduct) return <ProductCheckout product={selectedProduct} user={user} onBack={()=>setSelectedProduct(null)} onSuccess={()=>{setSelectedProduct(null);setSelectedShop(null);}} />;
  if (selectedShop) return <ShopPage shop={selectedShop} user={user} onBack={()=>setSelectedShop(null)} onBuy={setSelectedProduct} />;

  return (
    <div style={{position:'fixed',inset:0,background:C.bg,zIndex:300,display:'flex',flexDirection:'column'}}>
      <div style={{display:'flex',alignItems:'center',gap:12,padding:'16px 20px',borderBottom:`1px solid ${C.border}`}}>
        <button onClick={onClose} style={{background:'none',border:'none',color:C.muted,fontSize:22,cursor:'pointer'}}>←</button>
        <div style={{fontSize:18,fontWeight:700,color:C.text}}>🛒 Marketplace PayChat</div>
      </div>
      <div style={{display:'flex',borderBottom:`1px solid ${C.border}`}}>
        {[['explore','🔍 Explorer'],['myshop','🏪 Boutique'],['orders','📦 Commandes'],['links','🔗 Liens']].map(([t,l])=>(
          <button key={t} onClick={()=>setTab(t)} style={{flex:1,padding:'10px 0',background:'none',border:'none',color:tab===t?C.accent:C.muted,fontWeight:tab===t?700:400,fontSize:12,cursor:'pointer',borderBottom:tab===t?'2px solid '+C.accent:'none'}}>{l}</button>
        ))}
      </div>
      <div style={{flex:1,overflowY:'auto'}}>
        {tab==='explore' && (
          <div style={{padding:16}}>
            <input style={{width:'100%',background:C.card,border:'1px solid '+C.border,borderRadius:10,padding:'12px 14px',color:C.text,fontSize:14,outline:'none',boxSizing:'border-box',marginBottom:16}}
              placeholder="Rechercher une boutique..." value={search}
              onChange={e=>{setSearch(e.target.value);fetchShops(e.target.value);}} />
            {shops.length===0 ? (
              <div style={{textAlign:'center',marginTop:60}}>
                <div style={{fontSize:48,marginBottom:12}}>🛒</div>
                <div style={{color:C.muted,fontSize:14,marginBottom:16}}>Aucune boutique pour l instant</div>
                <button onClick={()=>setTab('myshop')} style={{background:C.accent,border:'none',borderRadius:12,padding:'12px 24px',color:'#000',fontWeight:700,cursor:'pointer'}}>Ouvrir ma boutique</button>
              </div>
            ) : shops.map(shop=>(
              <div key={shop.id} onClick={()=>setSelectedShop(shop)} style={{background:C.card,border:'1px solid '+C.border,borderRadius:16,padding:16,marginBottom:12,cursor:'pointer',display:'flex',alignItems:'center',gap:12}}>
                <div style={{width:48,height:48,borderRadius:24,background:C.accent+'33',display:'flex',alignItems:'center',justifyContent:'center',fontSize:20,flexShrink:0}}>🏪</div>
                <div style={{flex:1}}>
                  <div style={{fontSize:15,fontWeight:700,color:C.text}}>{shop.name}</div>
                  <div style={{fontSize:12,color:C.muted}}>{shop.category} · {shop.location||'Cameroun'} · {shop.total_sales} ventes</div>
                  {shop.description&&<div style={{fontSize:12,color:C.muted,marginTop:4}}>{shop.description}</div>}
                </div>
                <div style={{color:C.muted}}>→</div>
              </div>
            ))}
          </div>
        )}
        {tab==='myshop' && <MyShopTab user={user} />}
        {tab==='orders' && <OrdersTab />}
        {tab==='links' && <PaymentLinksTab />}
      </div>
    </div>
  );
}

function ShopPage({ shop, user, onBack, onBuy }) {
  const [products, setProducts] = useState([]);
  useEffect(()=>{
    api.get('/marketplace/shop/'+(shop.username||shop.display_name||'unknown')).then(res=>{
      setProducts(res.data?.products||[]);
    }).catch(()=>{});
  },[shop.id]);
  return (
    <div style={{position:'fixed',inset:0,background:C.bg,zIndex:310,display:'flex',flexDirection:'column'}}>
      <div style={{display:'flex',alignItems:'center',gap:12,padding:'16px 20px',borderBottom:'1px solid '+C.border}}>
        <button onClick={onBack} style={{background:'none',border:'none',color:C.muted,fontSize:22,cursor:'pointer'}}>←</button>
        <div style={{fontSize:17,fontWeight:700,color:C.text}}>{shop.name}</div>
      </div>
      <div style={{flex:1,overflowY:'auto',padding:16}}>
        {shop.description&&<div style={{color:C.muted,fontSize:13,marginBottom:16}}>{shop.description}</div>}
        {products.length===0 ? <div style={{textAlign:'center',marginTop:40,color:C.muted}}>Aucun produit disponible</div> : (
          <div style={{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12}}>
            {products.map(p=>(
              <div key={p.id} onClick={()=>onBuy(p)} style={{background:C.card,border:'1px solid '+C.border,borderRadius:14,overflow:'hidden',cursor:'pointer'}}>
                <div style={{height:120,background:C.surface,display:'flex',alignItems:'center',justifyContent:'center',overflow:'hidden'}}>
                  {p.image_url?<img src={p.image_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>:<div style={{fontSize:36}}>📦</div>}
                </div>
                <div style={{padding:10}}>
                  <div style={{fontSize:13,fontWeight:600,color:C.text,marginBottom:4}}>{p.name}</div>
                  <div style={{fontSize:15,fontWeight:800,color:C.accent}}>{fmt(p.price)} FCFA</div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
}

function ProductCheckout({ product, user, onBack, onSuccess }) {
  const [qty, setQty] = useState(1);
  const [pin, setPin] = useState('');
  const [note, setNote] = useState('');
  const [loading, setLoading] = useState(false);
  const total = parseFloat(product.price)*qty;
  const buy = async () => {
    if (pin.length<6) return toast.error('PIN incomplet');
    setLoading(true);
    try {
      const res = await api.post('/marketplace/orders',{product_id:product.id,quantity:qty,pin,note});
      toast.success(res.message||'Achat confirme !');
      onSuccess();
    } catch(e){toast.error(e?.error||'Erreur paiement');}
    finally{setLoading(false);}
  };
  return (
    <div style={{position:'fixed',inset:0,background:C.bg,zIndex:320,display:'flex',flexDirection:'column'}}>
      <div style={{display:'flex',alignItems:'center',gap:12,padding:'16px 20px',borderBottom:'1px solid '+C.border}}>
        <button onClick={onBack} style={{background:'none',border:'none',color:C.muted,fontSize:22,cursor:'pointer'}}>←</button>
        <div style={{fontSize:17,fontWeight:700,color:C.text}}>Confirmer l achat</div>
        <button onClick={onBack} style={{marginLeft:'auto',background:C.card,border:'1px solid '+C.border,borderRadius:8,padding:'6px 14px',color:C.muted,fontSize:13,cursor:'pointer'}}>Annuler</button>
      </div>
      <div style={{flex:1,overflowY:'auto',padding:20}}>
        <div style={{background:C.card,borderRadius:16,padding:16,marginBottom:20,display:'flex',gap:14,alignItems:'center'}}>
          <div style={{width:64,height:64,borderRadius:12,background:C.surface,overflow:'hidden',flexShrink:0,display:'flex',alignItems:'center',justifyContent:'center',fontSize:28}}>
            {product.image_url?<img src={product.image_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>:'📦'}
          </div>
          <div>
            <div style={{fontSize:15,fontWeight:700,color:C.text}}>{product.name}</div>
            <div style={{fontSize:18,fontWeight:800,color:C.accent,marginTop:4}}>{fmt(product.price)} FCFA</div>
          </div>
        </div>
        <div style={{marginBottom:16}}>
          <div style={{fontSize:13,color:C.muted,marginBottom:8}}>Quantite</div>
          <div style={{display:'flex',alignItems:'center',gap:16}}>
            <button onClick={()=>setQty(q=>Math.max(1,q-1))} style={{width:36,height:36,borderRadius:18,background:C.card,border:'1px solid '+C.border,color:C.text,fontSize:20,cursor:'pointer'}}>-</button>
            <div style={{fontSize:20,fontWeight:700,color:C.text}}>{qty}</div>
            <button onClick={()=>setQty(q=>q+1)} style={{width:36,height:36,borderRadius:18,background:C.card,border:'1px solid '+C.border,color:C.text,fontSize:20,cursor:'pointer'}}>+</button>
          </div>
        </div>
        <input style={{width:'100%',background:C.card,border:'1px solid '+C.border,borderRadius:10,padding:'10px 14px',color:C.text,fontSize:14,outline:'none',boxSizing:'border-box',marginBottom:16}}
          placeholder="Note au vendeur (optionnel)" value={note} onChange={e=>setNote(e.target.value)} />
        <div style={{background:C.card,borderRadius:12,padding:14,marginBottom:20}}>
          <div style={{display:'flex',justifyContent:'space-between',marginBottom:6}}>
            <span style={{color:C.muted,fontSize:13}}>Sous-total</span><span style={{color:C.text}}>{fmt(total)} FCFA</span>
          </div>
          <div style={{display:'flex',justifyContent:'space-between',marginBottom:6}}>
            <span style={{color:C.muted,fontSize:13}}>Commission (2%)</span><span style={{color:C.muted,fontSize:13}}>-{fmt(Math.round(total*0.02))} FCFA</span>
          </div>
          <div style={{borderTop:'1px solid '+C.border,paddingTop:8,display:'flex',justifyContent:'space-between'}}>
            <span style={{color:C.text,fontWeight:700}}>Total</span>
            <span style={{color:C.accent,fontWeight:800,fontSize:18}}>{fmt(total)} FCFA</span>
          </div>
        </div>
        <input type="password" inputMode="numeric" maxLength={6}
          style={{width:'100%',background:C.card,border:'1px solid '+C.border,borderRadius:10,padding:14,color:C.text,fontSize:24,textAlign:'center',letterSpacing:8,outline:'none',boxSizing:'border-box',marginBottom:16}}
          placeholder="PIN" value={pin} onChange={e=>setPin(e.target.value.replace(/\D/g,''))} />
        <button onClick={buy} disabled={loading} style={{width:'100%',background:C.accent,border:'none',borderRadius:14,padding:16,color:'#000',fontWeight:800,fontSize:16,cursor:'pointer',opacity:loading?0.6:1}}>
          {loading?'Traitement...':'Acheter - '+fmt(total)+' FCFA'}
        </button>
      </div>
    </div>
  );
}

function MyShopTab({ user }) {
  const [shop, setShop] = useState(null);
  const [products, setProducts] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [showAdd, setShowAdd] = useState(false);
  const [editingProduct, setEditingProduct] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(()=>{fetchMyShop();},[]);
  const fetchMyShop = async()=>{
    try{
      const res = await api.get('/marketplace/shop/me');
      setShop(res.data?.shop||null);
      setProducts(res.data?.products||[]);
    }catch{}finally{setLoading(false);}
  };
  if(loading) return <div style={{padding:40,textAlign:'center',color:C.muted}}>Chargement...</div>;
  if(!shop&&!showCreate) return (
    <div style={{padding:40,textAlign:'center'}}>
      <div style={{fontSize:48,marginBottom:16}}>🏪</div>
      <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:8}}>Ouvrez votre boutique</div>
      <div style={{fontSize:13,color:C.muted,marginBottom:24}}>Vendez vos produits et recevez les paiements sur votre wallet PayChat</div>
      <button onClick={()=>setShowCreate(true)} style={{background:C.accent,border:'none',borderRadius:12,padding:'14px 32px',color:'#000',fontWeight:700,cursor:'pointer'}}>Creer ma boutique</button>
    </div>
  );
  if(showCreate) return <CreateShopForm onCreated={()=>{setShowCreate(false);fetchMyShop();}} onCancel={()=>setShowCreate(false)} />;
  if(showAdd) return <AddProductForm onCreated={()=>{setShowAdd(false);fetchMyShop();}} onCancel={()=>setShowAdd(false)} />;
  if(editingProduct) return <EditProductForm product={editingProduct} onSaved={()=>{setEditingProduct(null);fetchMyShop();}} onCancel={()=>setEditingProduct(null)} />;
  const shopUrl = 'https://zenvoi.app/shop/'+(user?.username||'');
  return (
    <div style={{padding:16}}>
      <div style={{background:C.card,border:'1px solid '+C.accent+'33',borderRadius:16,padding:16,marginBottom:16}}>
        <div style={{fontSize:17,fontWeight:700,color:C.text,marginBottom:4}}>{shop.name}</div>
        <div style={{fontSize:12,color:C.muted,marginBottom:8}}>{shop.category} · {shop.total_sales} ventes</div>
        {shop.description&&<div style={{fontSize:13,color:C.muted,marginBottom:12}}>{shop.description}</div>}
        <div style={{background:C.surface,borderRadius:8,padding:10}}>
          <div style={{fontSize:11,color:C.muted,marginBottom:4}}>Lien de votre boutique</div>
          <div style={{fontSize:12,color:C.accent,wordBreak:'break-all',marginBottom:8}}>{shopUrl}</div>
          <button onClick={()=>{navigator.clipboard.writeText(shopUrl);toast.success('Lien copie !');}}
            style={{background:C.accent,border:'none',borderRadius:8,padding:'6px 14px',color:'#000',fontWeight:600,fontSize:12,cursor:'pointer'}}>Copier</button>
        </div>
      </div>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:12}}>
        <div style={{fontSize:14,fontWeight:600,color:C.text}}>Produits ({products.length})</div>
        <button onClick={()=>setShowAdd(true)} style={{background:C.accent,border:'none',borderRadius:8,padding:'8px 14px',color:'#000',fontWeight:700,fontSize:13,cursor:'pointer'}}>+ Ajouter</button>
      </div>
      {products.length===0 ? <div style={{textAlign:'center',padding:32,color:C.muted}}>Ajoutez votre premier produit</div> :
        products.map(p=>(
          <div key={p.id} style={{background:C.card,border:'1px solid '+C.border,borderRadius:12,padding:14,marginBottom:10,display:'flex',gap:12,alignItems:'center'}}>
            <div style={{width:48,height:48,borderRadius:10,background:C.surface,overflow:'hidden',flexShrink:0,display:'flex',alignItems:'center',justifyContent:'center'}}>
              {p.image_url?<img src={p.image_url} alt="" style={{width:'100%',height:'100%',objectFit:'cover'}}/>:'📦'}
            </div>
            <div style={{flex:1}}>
              <div style={{fontSize:14,fontWeight:600,color:C.text}}>{p.name}</div>
              <div style={{fontSize:15,fontWeight:700,color:C.accent}}>{fmt(p.price)} FCFA</div>
              <div style={{fontSize:11,color:C.muted}}>{p.total_sold} vendu(s) · Stock: {p.stock===-1?'Illimité':p.stock}</div>
            </div>
            <button onClick={()=>setEditingProduct(p)}
              style={{background:C.card,border:'1px solid '+C.border,borderRadius:8,padding:'6px 12px',color:C.accent,fontSize:12,fontWeight:600,cursor:'pointer',flexShrink:0}}>
              ✏️
            </button>
          </div>
        ))
      }
    </div>
  );
}

function CreateShopForm({ onCreated, onCancel }) {
  const [form, setForm] = useState({name:'',description:'',category:'',phone:'',location:''});
  const [loading, setLoading] = useState(false);
  const inp = {width:'100%',background:C.card,border:'1px solid '+C.border,borderRadius:10,padding:'12px 14px',color:C.text,fontSize:14,outline:'none',boxSizing:'border-box',marginBottom:14};
  const submit = async()=>{
    if(!form.name) return toast.error('Nom requis');
    setLoading(true);
    try{await api.post('/marketplace/shop',form);toast.success('Boutique creee !');onCreated();}
    catch(e){toast.error(e?.error||'Erreur');}finally{setLoading(false);}
  };
  return (
    <div style={{padding:20}}>
      <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:20}}>Creer ma boutique</div>
      <input style={inp} placeholder="Nom de la boutique *" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} />
      <input style={inp} placeholder="Description" value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} />
      <select style={inp} value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))}>
        <option value="">Categorie...</option>
        {CATEGORIES.map(c=><option key={c} value={c}>{c}</option>)}
      </select>
      <input style={inp} placeholder="+237 6XX XXX XXX" value={form.phone} onChange={e=>setForm(f=>({...f,phone:e.target.value}))} />
      <input style={inp} placeholder="Localisation (ex: Akwa, Douala)" value={form.location} onChange={e=>setForm(f=>({...f,location:e.target.value}))} />
      <div style={{display:'flex',gap:10}}>
        <button onClick={onCancel} style={{flex:1,background:C.card,border:'1px solid '+C.border,borderRadius:12,padding:14,color:C.muted,fontWeight:600,cursor:'pointer'}}>Annuler</button>
        <button onClick={submit} disabled={loading} style={{flex:2,background:C.accent,border:'none',borderRadius:12,padding:14,color:'#000',fontWeight:700,cursor:'pointer',opacity:loading?0.6:1}}>
          {loading?'Creation...':'Creer la boutique'}
        </button>
      </div>
    </div>
  );
}

function AddProductForm({ onCreated, onCancel }) {
  const [form, setForm] = useState({name:'',description:'',price:'',category:'',image_url:'',stock:''});
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [pendingFile, setPendingFile] = useState(null);
  const fileRef = useRef(null);
  const inp = {width:'100%',background:C.card,border:'1px solid '+C.border,borderRadius:10,padding:'12px 14px',color:C.text,fontSize:14,outline:'none',boxSizing:'border-box',marginBottom:14};

  const resizeAndUpload = async(file, rot=0)=>{
    setUploading(true);
    try{
      const dataURL = await new Promise((res,rej)=>{const r=new FileReader();r.onload=e=>res(e.target.result);r.onerror=rej;r.readAsDataURL(file);});
      const img = await new Promise((res,rej)=>{const i=new Image();i.onload=()=>res(i);i.onerror=rej;i.src=dataURL;});
      const SIZE=800;
      const canvas=document.createElement('canvas');
      canvas.width=SIZE;canvas.height=SIZE;
      const ctx=canvas.getContext('2d');
      ctx.fillStyle='#ffffff';ctx.fillRect(0,0,SIZE,SIZE);
      ctx.save();ctx.translate(SIZE/2,SIZE/2);ctx.rotate((rot*Math.PI)/180);
      const scale=Math.max(SIZE/img.width,SIZE/img.height);
      ctx.drawImage(img,-img.width*scale/2,-img.height*scale/2,img.width*scale,img.height*scale);
      ctx.restore();
      const blob=await new Promise(r=>canvas.toBlob(r,'image/jpeg',0.85));
      const fd=new FormData();fd.append('file',blob,'product.jpg');
      const res=await api.post('/media/upload',fd,{headers:{'Content-Type':'multipart/form-data'}});
      setForm(f=>({...f,image_url:res.url||res.data?.url||res.fileUrl||''}));
      toast.success('Photo OK (800x800)');
    }catch(e){toast.error('Erreur: '+e.message);}finally{setUploading(false);}
  };

  const uploadImage = async(file)=>{setPendingFile(file);setRotation(0);await resizeAndUpload(file,0);};
  const rotate = async()=>{if(!pendingFile)return;const r=(rotation+90)%360;setRotation(r);await resizeAndUpload(pendingFile,r);};
  const submit = async()=>{
    if(!form.name||!form.price) return toast.error('Nom et prix requis');
    setLoading(true);
    try{
      await api.post('/marketplace/products',{...form,price:parseFloat(form.price),stock:parseInt(form.stock)||(-1)});
      toast.success('Produit ajoute !');onCreated();
    }catch(e){toast.error(e?.error||'Erreur');}finally{setLoading(false);}
  };
  return (
    <div style={{padding:20}}>
      <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:20}}>Ajouter un produit</div>
      <input ref={fileRef} type="file" accept="image/*" onChange={e=>e.target.files?.[0]&&uploadImage(e.target.files[0])} style={{display:'none'}} />
      <div onClick={()=>fileRef.current?.click()} style={{height:220,background:C.card,border:'2px dashed '+C.border,borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',marginBottom:14,overflow:'hidden',position:'relative'}}>
        {form.image_url
          ? <img src={form.image_url} alt="" style={{width:'100%',height:'100%',objectFit:'contain',background:'#000'}}/>
          : <div style={{textAlign:'center',color:C.muted,fontSize:14}}>{uploading?'⏳ Traitement...':'📷 Appuyez pour ajouter une photo'}</div>}
        {form.image_url && <div style={{position:'absolute',top:8,right:8,background:'#000000bb',borderRadius:8,padding:'4px 10px',fontSize:11,color:'#fff'}}>Changer</div>}
      </div>
      {pendingFile && (
        <button onClick={rotate} disabled={uploading}
          style={{width:'100%',background:C.card,border:'1px solid '+C.border,borderRadius:10,padding:'10px 0',color:C.accent,fontWeight:600,fontSize:14,cursor:'pointer',marginBottom:14}}>
          {uploading ? 'Rotation...' : '🔄 Faire pivoter ('+rotation+'°)'}
        </button>
      )}
      <input style={inp} placeholder="Nom du produit *" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} />
      <input style={inp} placeholder="Description" value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} />
      <input style={inp} type="number" placeholder="Prix en FCFA *" value={form.price} onChange={e=>setForm(f=>({...f,price:e.target.value}))} />
      <select style={inp} value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))}>
        <option value="">Categorie...</option>
        {CATEGORIES.map(c=><option key={c} value={c}>{c}</option>)}
      </select>
      <input style={inp} type="number" placeholder="Stock (vide = illimite)" value={form.stock} onChange={e=>setForm(f=>({...f,stock:e.target.value}))} />
      <div style={{display:'flex',gap:10}}>
        <button onClick={onCancel} style={{flex:1,background:C.card,border:'1px solid '+C.border,borderRadius:12,padding:14,color:C.muted,fontWeight:600,cursor:'pointer'}}>Annuler</button>
        <button onClick={submit} disabled={loading} style={{flex:2,background:C.accent,border:'none',borderRadius:12,padding:14,color:'#000',fontWeight:700,cursor:'pointer',opacity:loading?0.6:1}}>
          {loading?'Ajout...':'Ajouter le produit'}
        </button>
      </div>
    </div>
  );
}

function OrdersTab() {
  const [tab, setTab] = useState('purchases');
  const [data, setData] = useState({purchases:[],sales:[]});
  useEffect(()=>{api.get('/marketplace/orders').then(res=>setData(res.data||res)).catch(()=>{});},[]);
  const orders = tab==='purchases'?data.purchases:data.sales;
  const statusColor = {pending:'#F59E0B',paid:'#00D4AA',delivered:'#2E7D6B',cancelled:'#FF4F6A'};
  const statusLabel = {pending:'En attente',paid:'Paye',delivered:'Livre',cancelled:'Annule'};
  return (
    <div style={{padding:16}}>
      <div style={{display:'flex',gap:8,marginBottom:16}}>
        {[['purchases','Mes achats'],['sales','Mes ventes']].map(([t,l])=>(
          <button key={t} onClick={()=>setTab(t)} style={{flex:1,padding:'10px 0',background:tab===t?C.accent+'22':C.card,border:'1px solid '+(tab===t?C.accent:C.border),borderRadius:10,color:tab===t?C.accent:C.muted,fontWeight:tab===t?700:400,cursor:'pointer',fontSize:13}}>{l}</button>
        ))}
      </div>
      {orders.length===0?<div style={{textAlign:'center',padding:40,color:C.muted}}>Aucune commande</div>:
        orders.map(o=>(
          <div key={o.id} style={{background:C.card,border:'1px solid '+C.border,borderRadius:12,padding:14,marginBottom:10}}>
            <div style={{display:'flex',justifyContent:'space-between',marginBottom:6}}>
              <div style={{fontSize:14,fontWeight:600,color:C.text}}>{o.product_name}</div>
              <span style={{fontSize:11,color:statusColor[o.status],background:statusColor[o.status]+'22',padding:'2px 8px',borderRadius:8}}>{statusLabel[o.status]}</span>
            </div>
            <div style={{fontSize:12,color:C.muted}}>{tab==='purchases'?'Vendeur: '+o.seller_name:'Acheteur: '+o.buyer_name}</div>
            <div style={{display:'flex',justifyContent:'space-between',marginTop:6}}>
              <div style={{fontSize:12,color:C.muted}}>Qte: {o.quantity}</div>
              <div style={{fontSize:15,fontWeight:700,color:C.accent}}>{fmt(o.amount)} FCFA</div>
            </div>
          </div>
        ))
      }
    </div>
  );
}

function PaymentLinksTab() {
  const [links, setLinks] = useState([]);
  const [showCreate, setShowCreate] = useState(false);
  const [form, setForm] = useState({title:'',description:'',amount:'',max_uses:''});
  const [loading, setLoading] = useState(false);
  useEffect(()=>{fetchLinks();},[]);
  const fetchLinks = async()=>{
    try{const res=await api.get('/marketplace/shop/me');setLinks(res.data?.links||[]);}catch{}
  };
  const createLink = async()=>{
    if(!form.title) return toast.error('Titre requis');
    setLoading(true);
    try{
      await api.post('/marketplace/links',{title:form.title,description:form.description,amount:form.amount?parseFloat(form.amount):null,max_uses:form.max_uses?parseInt(form.max_uses):-1});
      toast.success('Lien cree !');setShowCreate(false);setForm({title:'',description:'',amount:'',max_uses:''});fetchLinks();
    }catch(e){toast.error(e?.error||'Erreur');}finally{setLoading(false);}
  };
  const inp = {width:'100%',background:C.card,border:'1px solid '+C.border,borderRadius:10,padding:'12px 14px',color:C.text,fontSize:14,outline:'none',boxSizing:'border-box',marginBottom:14};
  return (
    <div style={{padding:16}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
        <div style={{fontSize:14,fontWeight:600,color:C.text}}>Liens de paiement</div>
        <button onClick={()=>setShowCreate(s=>!s)} style={{background:C.accent,border:'none',borderRadius:8,padding:'8px 14px',color:'#000',fontWeight:700,fontSize:13,cursor:'pointer'}}>{showCreate?'Annuler':'+ Creer'}</button>
      </div>
      {showCreate&&(
        <div style={{background:C.card,border:'1px solid '+C.accent+'33',borderRadius:14,padding:16,marginBottom:16}}>
          <input style={inp} placeholder="Titre *" value={form.title} onChange={e=>setForm(f=>({...f,title:e.target.value}))} />
          <input style={inp} placeholder="Description" value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} />
          <input style={inp} type="number" placeholder="Montant fixe (vide = libre)" value={form.amount} onChange={e=>setForm(f=>({...f,amount:e.target.value}))} />
          <input style={inp} type="number" placeholder="Limite utilisations (vide = illimite)" value={form.max_uses} onChange={e=>setForm(f=>({...f,max_uses:e.target.value}))} />
          <button onClick={createLink} disabled={loading} style={{width:'100%',background:C.accent,border:'none',borderRadius:12,padding:14,color:'#000',fontWeight:700,cursor:'pointer',opacity:loading?0.6:1}}>
            {loading?'Creation...':'Generer le lien'}
          </button>
        </div>
      )}
      {links.length===0?(
        <div style={{textAlign:'center',padding:40}}>
          <div style={{fontSize:48,marginBottom:12}}>🔗</div>
          <div style={{color:C.text,fontWeight:600,marginBottom:8}}>Aucun lien</div>
          <div style={{color:C.muted,fontSize:13}}>Creez un lien et partagez-le sur WhatsApp, TikTok, Instagram</div>
        </div>
      ):links.map(link=>(
        <div key={link.id} style={{background:C.card,border:'1px solid '+C.border,borderRadius:12,padding:14,marginBottom:10}}>
          <div style={{fontSize:14,fontWeight:600,color:C.text,marginBottom:4}}>{link.title}</div>
          {link.description&&<div style={{fontSize:12,color:C.muted,marginBottom:6}}>{link.description}</div>}
          <div style={{display:'flex',justifyContent:'space-between',marginBottom:8}}>
            <div style={{fontSize:13,color:C.accent,fontWeight:700}}>{link.amount?fmt(link.amount)+' FCFA':'Montant libre'}</div>
            <div style={{fontSize:12,color:C.muted}}>{link.uses_count} utilisation(s)</div>
          </div>
          <div style={{background:C.surface,borderRadius:8,padding:'8px 10px',fontSize:12,color:C.muted,marginBottom:10,wordBreak:'break-all'}}>
            https://zenvoi.app/pay/{link.code}
          </div>
          <div style={{display:'flex',gap:8}}>
            <button onClick={()=>{navigator.clipboard.writeText('https://zenvoi.app/pay/'+link.code);toast.success('Lien copie ! Partagez-le !');}}
              style={{flex:2,background:C.accent,border:'none',borderRadius:8,padding:'10px 0',color:'#000',fontWeight:700,fontSize:13,cursor:'pointer'}}>Copier et partager</button>
            <button onClick={async()=>{await api.delete('/marketplace/links/'+link.id);toast.success('Supprime');fetchLinks();}}
              style={{flex:1,background:C.card,border:'1px solid '+C.red,borderRadius:8,padding:'10px 0',color:C.red,fontWeight:600,fontSize:13,cursor:'pointer'}}>Suppr.</button>
          </div>
        </div>
      ))}
    </div>
  );
}

function EditProductForm({ product, onSaved, onCancel }) {
  const [form, setForm] = useState({
    name: product.name || '',
    description: product.description || '',
    price: product.price || '',
    category: product.category || '',
    image_url: product.image_url || '',
    stock: product.stock === -1 ? '' : product.stock || '',
    is_available: product.is_available !== false,
  });
  const [uploading, setUploading] = useState(false);
  const [loading, setLoading] = useState(false);
  const fileRef = useRef(null);

  const [rotation, setRotation] = useState(0);
  const [preview, setPreview] = useState(form.image_url || null);
  const [pendingFile, setPendingFile] = useState(null);

  const resizeAndUpload = async (file, rot = 0) => {
    setUploading(true);
    try {
      const dataURL = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => resolve(e.target.result);
        reader.onerror = reject;
        reader.readAsDataURL(file);
      });
      const img = await new Promise((resolve, reject) => {
        const i = new Image();
        i.onload = () => resolve(i);
        i.onerror = reject;
        i.src = dataURL;
      });
      // Canvas carré 800x800
      const SIZE = 800;
      const canvas = document.createElement('canvas');
      canvas.width = SIZE; canvas.height = SIZE;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, SIZE, SIZE);
      // Rotation
      ctx.save();
      ctx.translate(SIZE/2, SIZE/2);
      ctx.rotate((rot * Math.PI) / 180);
      // Centrer et couvrir en carré
      const scale = Math.max(SIZE / img.width, SIZE / img.height);
      const sw = img.width * scale;
      const sh = img.height * scale;
      ctx.drawImage(img, -sw/2, -sh/2, sw, sh);
      ctx.restore();
      // Convertir en blob JPEG 85%
      const blob = await new Promise(resolve => canvas.toBlob(resolve, 'image/jpeg', 0.85));
      setPreview(canvas.toDataURL('image/jpeg', 0.85));
      const fd = new FormData();
      fd.append('file', blob, 'product.jpg');
      const res = await api.post('/media/upload', fd, { headers: {'Content-Type':'multipart/form-data'} });
      const url = res.url || res.data?.url || res.fileUrl || '';
      setForm(f => ({...f, image_url: url}));
      toast.success('Photo mise à jour (800x800)');
    } catch(e) { toast.error('Erreur upload: ' + e.message); }
    finally { setUploading(false); }
  };

  const uploadImage = async (file) => {
    setPendingFile(file);
    setRotation(0);
    await resizeAndUpload(file, 0);
  };

  const rotate = async () => {
    if (!pendingFile) return;
    const newRot = (rotation + 90) % 360;
    setRotation(newRot);
    await resizeAndUpload(pendingFile, newRot);
    toast('🔄 Rotation ' + newRot + '°');
  };

  const save = async () => {
    if (!form.name || !form.price) return toast.error('Nom et prix requis');
    setLoading(true);
    try {
      await api.put('/marketplace/products/'+product.id, {
        ...form,
        price: parseFloat(form.price),
        stock: form.stock === '' ? -1 : parseInt(form.stock),
      });
      toast.success('Produit mis à jour !');
      onSaved();
    } catch(e) { toast.error(e?.error || 'Erreur'); }
    finally { setLoading(false); }
  };

  const inp = {width:'100%',background:C.card,border:'1px solid '+C.border,borderRadius:10,padding:'12px 14px',color:C.text,fontSize:14,outline:'none',boxSizing:'border-box',marginBottom:14};

  return (
    <div style={{padding:20}}>
      <div style={{fontSize:16,fontWeight:700,color:C.text,marginBottom:20}}>✏️ Modifier le produit</div>
      <input ref={fileRef} type="file" accept="image/*" onChange={e=>e.target.files?.[0]&&uploadImage(e.target.files[0])} style={{display:'none'}} />

      {/* Photo */}
      <div onClick={()=>fileRef.current?.click()}
        style={{height:220,background:C.card,border:'2px dashed '+C.accent,borderRadius:12,display:'flex',alignItems:'center',justifyContent:'center',cursor:'pointer',marginBottom:14,overflow:'hidden',position:'relative'}}>
        {form.image_url
          ? <img src={form.image_url} alt="" style={{width:'100%',height:'100%',objectFit:'contain',background:'#000'}}/>
          : <div style={{textAlign:'center',color:C.muted}}>{uploading?'⏳ Traitement...':'📷 Changer la photo'}</div>}
        {form.image_url && <div style={{position:'absolute',top:8,right:8,background:'#000000aa',borderRadius:8,padding:'4px 10px',fontSize:11,color:'#fff'}}>Changer</div>}
      </div>
      {pendingFile && (
        <button onClick={rotate} disabled={uploading}
          style={{width:'100%',background:C.card,border:'1px solid '+C.border,borderRadius:10,padding:'10px 0',color:C.accent,fontWeight:600,fontSize:14,cursor:'pointer',marginBottom:14}}>
          🔄 Faire pivoter la photo
        </button>
      )}
      {pendingFile && (
        <button onClick={rotate} disabled={uploading}
          style={{width:'100%',background:C.card,border:'1px solid '+C.border,borderRadius:10,padding:'10px 0',color:C.accent,fontWeight:600,fontSize:14,cursor:'pointer',marginBottom:14}}>
          🔄 Faire pivoter la photo
        </button>
      )}

      <input style={inp} placeholder="Nom du produit *" value={form.name} onChange={e=>setForm(f=>({...f,name:e.target.value}))} />
      <input style={inp} placeholder="Description" value={form.description} onChange={e=>setForm(f=>({...f,description:e.target.value}))} />
      <input style={inp} type="number" placeholder="Prix en FCFA *" value={form.price} onChange={e=>setForm(f=>({...f,price:e.target.value}))} />
      <select style={inp} value={form.category} onChange={e=>setForm(f=>({...f,category:e.target.value}))}>
        <option value="">Catégorie...</option>
        {CATEGORIES.map(c=><option key={c} value={c}>{c}</option>)}
      </select>
      <input style={inp} type="number" placeholder="Stock (vide = illimité)" value={form.stock} onChange={e=>setForm(f=>({...f,stock:e.target.value}))} />

      {/* Disponibilité */}
      <div style={{display:'flex',alignItems:'center',gap:12,marginBottom:20,padding:'12px 14px',background:C.card,borderRadius:10,border:'1px solid '+C.border}}>
        <div style={{flex:1,fontSize:14,color:C.text}}>Produit disponible à la vente</div>
        <div onClick={()=>setForm(f=>({...f,is_available:!f.is_available}))}
          style={{width:44,height:24,borderRadius:12,background:form.is_available?C.accent:'#444',cursor:'pointer',position:'relative',transition:'background 0.2s'}}>
          <div style={{position:'absolute',top:2,left:form.is_available?20:2,width:20,height:20,borderRadius:10,background:'#fff',transition:'left 0.2s'}}/>
        </div>
      </div>

      <div style={{display:'flex',gap:10}}>
        <button onClick={onCancel} style={{flex:1,background:C.card,border:'1px solid '+C.border,borderRadius:12,padding:14,color:C.muted,fontWeight:600,cursor:'pointer'}}>Annuler</button>
        <button onClick={save} disabled={loading} style={{flex:2,background:C.accent,border:'none',borderRadius:12,padding:14,color:'#000',fontWeight:700,cursor:'pointer',opacity:loading?0.6:1}}>
          {loading?'Sauvegarde...':'✅ Enregistrer'}
        </button>
      </div>
    </div>
  );
}
